import { Component, OnInit } from '@angular/core';
import { Datalistrequestfilter } from '../../request/datalistrequestfilter';
import { IFilterFilters } from '../ifilter';

@Component({
    selector: '[app-collections-state-filter]',
    templateUrl: './collections-state-filter.component.html',
    styleUrls: ['./collections-state-filter.component.scss'],
    host: { 'class': 'control' },
    standalone: false
})
export class CollectionsStateFilterComponent implements OnInit, IFilterFilters {
  public QueryParamPrefix: string = '';
  public FilterName: string = "collectionsstate";
  public Filters: Datalistrequestfilter[] = [];

  // Default to Missing (i.e. "available for Collections") so the screen is useful on first load.
  public SelectedState: string = "missing";

  ngOnInit(): void {
    this.Apply();
  }

  public StateChanged(event: any): void {
    this.SelectedState = event?.target?.value ?? "all";
    this.Apply();
  }

  public Apply(): void {
    this.Filters = [];
    const s = (this.SelectedState || "all").toLowerCase();
    if (s === "all" || s === "") {
      return;
    }

    // ICitation.CollectionsState: Missing=0, Pending=1, Collected=2
    let val = "";
    if (s === "missing") val = "0";
    else if (s === "pending") val = "1";
    else if (s === "collected") val = "2";
    else return;

    this.Filters.push({
      Property: "CollectionsState",
      Comparator: "==",
      Value: val,
      FilterName: this.FilterName
    });
  }
}

